var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMembershipPolicy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.2,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 2.257V7.67c0 3.503 2.178 6.645 5.48 7.902l.747.285c.497.19 1.049.19 1.546 0l.748-.285C12.82 14.316 15 11.174 15 7.671V2.257a1.057 1.057 0 0 0-.623-.969A15.709 15.709 0 0 0 8 .001a15.709 15.709 0 0 0-6.377 1.287A1.057 1.057 0 0 0 1 2.257z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.733 7.467c-.287 1.972-2.087 3.373-4.089 3.183-2.002-.19-3.501-1.903-3.406-3.893.095-1.99 1.75-3.555 3.762-3.556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.77 4.133 8.332 7.537a.475.475 0 0 1-.666 0L6.59 6.467"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembershipPolicy);
export default __webpack_public_path__ + "static/media/membership-policy.66a38af68734c9d1403faa4fefa0cc53.svg";
export { ForwardRef as ReactComponent };